function daysInMonth(month, year) {
    let mes = parseInt(month)
     return new Date(year, mes, 0).getDate()
  }

  function run(mes, ciclo, totalDays, data){
    let calendar = []
    const dias = [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
    ]
    
    for(let i = 1;i<=totalDays;i++) {
      calendar.push({ 
            events: data?.filter(e => e[`D${i}`] && e[`D${i}`]),
            dateIndex: i,
            dayIndex: dias.indexOf(new Date(`${ciclo}-${mes}-${i}`).toString().split(" ")[0]),
            date:`${ciclo}-${mes}-${i.toString().padStart(2,"0")}`,
            dayName:new Date(`${ciclo}-${mes}-${i}`).toString().split(" ")[0]
          })
    }
    return calendar
  }
  
  function rellenar(mes, ciclo, totalDays, data){
   const mesStr = mes.toString().padStart(2,"0")
    let array = run(mesStr, ciclo, totalDays, data)
    let primerLimite = array[0]['dayIndex']
    let primerComplemento = []
    for(let i = 0;i<primerLimite ;i++){
      primerComplemento.push({ 
             dateIndex: '',
             dayIndex: i,
             date:`------`,
             dayName:'------'
      })
    }
    return primerComplemento.concat(array)
  }

  export {
    daysInMonth,
    rellenar
  }